module.exports = __webpack_public_path__ + "static/media/logo_tecnologia.91ea0d74.png";